import { IS_BROWSER } from 'redux-bundler'

export default IS_BROWSER &&
  window.matchMedia &&
  window.matchMedia('(display-mode: standalone)').matches
